/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CustomMetricConfigurationBatchResponse {
    getFixupPrototypeFunction() { return CustomMetricConfigurationBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<CustomMetricConfigurationBatchResponse>): CustomMetricConfigurationBatchResponse {
        let obj = Object.assign(new CustomMetricConfigurationBatchResponse(), model);
        CustomMetricConfigurationBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CustomMetricConfigurationBatchResponse>): CustomMetricConfigurationBatchResponse {
        if (!model) return null;
        return CustomMetricConfigurationBatchResponse.newInstance(<CustomMetricConfigurationBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CustomMetricConfigurationBatchResponse) {
        if (!obj) return;

        models.CustomMetricConfigurationBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CustomMetricConfigurationBatchResponse): boolean {
        Object.setPrototypeOf(obj, CustomMetricConfigurationBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.CustomMetricConfigurationDetails.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.CustomMetricConfigurationDetails; };

}
